<template>
  <div>
    <div class="form-group">
      <c-switcher v-model="form.medicalBook" label="Наличие медицинской книжки" />
    </div>

    <div>
      <div class="form-group">
        <c-switcher v-model="form.salaryShow" label="Желаемая зарплата" />
      </div>

      <transition name="slide">
        <div v-if="form.salaryShow" class="params">
          <c-switcher v-model="form.salaryRequired" type="checkbox" label="Обязательное" />
        </div>
      </transition>
    </div>

    <div>
      <div class="form-group">
        <c-switcher v-model="form.schedule.show" label="Желаемый график работы" />
      </div>

      <transition name="slide">
        <div v-if="form.schedule.show" class="params">
          <list-params
            :form="form.schedule"
            field-name="График работы"
            :field-type="fieldType"
            @change="$emit('editDictionary', 'schedule')"
          />
        </div>
      </transition>
    </div>

    <div>
      <div class="form-group">
        <c-switcher v-model="form.workStartShow" label="Когда сможете приступить к работе" />
      </div>

      <transition name="slide">
        <div v-if="form.workStartShow" class="params">
          <c-switcher v-model="form.workStartRequired" type="checkbox" label="Обязательное" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CSwitcher from "@/components/controls/switcher";
import ListParams from "@/pages/profile/form/components/ListParams";

export default {
  components: { CSwitcher, ListParams },
  props: ["form", "field", "fieldType"],
};
</script>

<style lang="scss" scoped>
.params {
  padding-left: 20px;

  padding-bottom: 25px;
}
</style>
